var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',[_c('v-expansion-panel-header',{attrs:{"color":"green lighten-4"}},[_vm._v(" Pagos ")]),_c('v-expansion-panel-content',[_vm._v(" aqui la tabla ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }